const guideMixin = {
	data() {
		return {
			guideStep: 0
		}
	},
	mounted() {
		this.eventBus.$on('guidePrevClick', () => {
			this.guideStep -= 1
			if (this.guideStep <= 0) this.guideStep = 0
			if (this.guideStep === 6) this.eventBus.$emit('guideStepFastClick', false)
			if (this.guideStep === 7) this.eventBus.$emit('guideStepFastClick', true)
			if (this.guideStep === 8) this.eventBus.$emit('guideStepScoreBoard', false)
			if (this.guideStep === 9) this.eventBus.$emit('guideStepScoreBoard', true)
			if (this.guideStep === 10) this.eventBus.$emit('guideStepHistoryScore', true)
		})

		this.eventBus.$on('guideNextClick', () => {
			this.guideStep += 1
			if (this.guideStep === 7) this.eventBus.$emit('guideStepFastClick', true)
			if (this.guideStep === 8) this.eventBus.$emit('guideStepFastClick', false)
			if (this.guideStep === 9) this.eventBus.$emit('guideStepScoreBoard', true)
			if (this.guideStep === 10) this.eventBus.$emit('guideStepScoreBoard', false)
			if (this.guideStep === 11) this.eventBus.$emit('guideStepHistoryScore', false)
		})
	}
}
export default guideMixin
